module.exports = __webpack_public_path__ + "img/ic_visited.08e15be3.svg";